(function() {
  function parseNumber(value) {
    var normalized = String(value || "").replace(/[^0-9.]/g, "");
    var parts = normalized.split(".");
    if (parts.length > 2) {
      normalized = parts[0] + "." + parts.slice(1).join("");
    }
    var parsed = parseFloat(normalized);
    return isFinite(parsed) ? parsed : NaN;
  }

  function formatMoney(amount) {
    if (!isFinite(amount)) {
      return "&ndash;";
    }

    return "$" + Math.round(amount).toLocaleString("en-US");
  }

  function formatPercent(value) {
    var rounded = Math.round(value * 10) / 10;
    return (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)) + "%";
  }

  function conversionBand(rate) {
    if (rate < 1.5) {
      return "below";
    }
    if (rate < 2.5) {
      return "average";
    }
    if (rate < 4) {
      return "good";
    }
    return "excellent";
  }

  function bandLabel(band) {
    return {
      below: "below average",
      average: "average",
      good: "good",
      excellent: "excellent"
    }[band];
  }

  function initCalculator(root) {
    var inputs = {
      visitors: root.querySelector('[data-conv-input="visitors"]'),
      cvr: root.querySelector('[data-conv-input="cvr"]'),
      aov: root.querySelector('[data-conv-input="aov"]'),
      target: root.querySelector('[data-conv-input="target"]')
    };

    var outputs = {
      revenueNow: document.querySelector('[data-conv-output="revenue-now"]'),
      revenueTarget: document.querySelector('[data-conv-output="revenue-target"]'),
      leakMonth: document.querySelector('[data-conv-output="leak-month"]'),
      leakYear: document.querySelector('[data-conv-output="leak-year"]'),
      routePillar: document.querySelector('[data-conv-output="route-pillar"]'),
      routeWhy: document.querySelector('[data-conv-output="route-why"]'),
      scaleText: document.querySelector('[data-conv-output="scale-text"]')
    };

    var segments = Array.prototype.slice.call(document.querySelectorAll("[data-conv-band]"));

    function setHint(key, message, isBad) {
      var hint = root.querySelector('[data-conv-hint="' + key + '"]');
      var input = inputs[key];

      if (!hint || !input) {
        return;
      }

      if (key === "target" && !message) {
        hint.textContent = hint.getAttribute("data-default-hint") || "";
        hint.className = "hint";
        input.classList.remove("err");
        return;
      }

      hint.textContent = message || "";
      hint.className = "hint" + (isBad ? " bad" : "");
      input.classList.toggle("err", !!isBad);
    }

    function update() {
      var visitors = parseNumber(inputs.visitors.value);
      var cvr = parseNumber(inputs.cvr.value);
      var aov = parseNumber(inputs.aov.value);
      var target = parseNumber(inputs.target.value);
      var valid = true;

      if (!(visitors > 0)) {
        setHint("visitors", "Enter your monthly visitors.", true);
        valid = false;
      } else if (visitors > 1000000000) {
        setHint("visitors", "That's a lot. Double-check the number.", true);
        valid = false;
      } else {
        setHint("visitors", "");
      }

      if (!(cvr > 0)) {
        setHint("cvr", "Enter a rate above 0.", true);
        valid = false;
      } else if (cvr > 100) {
        setHint("cvr", "Over 100% isn't possible. Check the number.", true);
        valid = false;
      } else if (cvr < 0.1) {
        setHint("cvr", "Looks like a fraction. Enter it as a percent, e.g. 1.8.");
      } else {
        setHint("cvr", "");
      }

      if (!(aov > 0)) {
        setHint("aov", "Enter your average order value.", true);
        valid = false;
      } else {
        setHint("aov", "");
      }

      if (inputs.target.value.trim() === "" || !(target > 0)) {
        target = Math.max(cvr, 3.0);
        setHint("target", "");
      } else if (target > 100) {
        setHint("target", "That's over 100%. Check the number.", true);
        valid = false;
      } else {
        setHint("target", "");
      }

      if (cvr > 0 && cvr <= 100) {
        var band = conversionBand(cvr);
        segments.forEach(function(segment) {
          segment.classList.toggle("is-active", segment.getAttribute("data-conv-band") === band);
        });

        if (outputs.scaleText) {
          outputs.scaleText.innerHTML = "Your store, at <b>" + formatPercent(cvr) + "</b>, sits in the <b>" + bandLabel(band) + "</b> band.";
        }
      } else {
        segments.forEach(function(segment) {
          segment.classList.remove("is-active");
        });

        if (outputs.scaleText) {
          outputs.scaleText.textContent = "Enter your conversion rate to see where you land.";
        }
      }

      if (!valid) {
        return;
      }

      var revenueNow = visitors * (cvr / 100) * aov;
      var effectiveTarget = Math.max(target, cvr);
      var revenueTarget = visitors * (effectiveTarget / 100) * aov;
      var leak = Math.max(0, revenueTarget - revenueNow);

      if (outputs.revenueNow) {
        outputs.revenueNow.innerHTML = formatMoney(revenueNow) + "<span class='unit'>/mo</span>";
      }

      if (outputs.revenueTarget) {
        outputs.revenueTarget.innerHTML = formatMoney(revenueTarget) + "<span class='unit'>/mo</span>";
      }

      if (outputs.leakMonth) {
        outputs.leakMonth.innerHTML = formatMoney(leak) + "<span class='unit unit--big'>/mo</span>";
      }

      if (leak < 1) {
        if (outputs.leakYear) {
          outputs.leakYear.textContent = "You're already at your target, so the next gains are in retention.";
        }
        if (outputs.routePillar) {
          outputs.routePillar.textContent = "Retention · Purchase Loop";
        }
        if (outputs.routeWhy) {
          outputs.routeWhy.textContent = "At or above target on conversion, the cheapest growth left is the second purchase, designed not hoped for.";
        }
      } else {
        if (outputs.leakYear) {
          outputs.leakYear.textContent = "that's " + formatMoney(leak * 12) + " a year left on the table";
        }

        if (aov < 50) {
          if (outputs.routePillar) {
            outputs.routePillar.textContent = "Conversion · Offer Design";
          }
          if (outputs.routeWhy) {
            outputs.routeWhy.textContent = "Your order value is doing the heavy lifting. The offer likely isn't carrying its price, so buyers hesitate.";
          }
        } else if (cvr < 2) {
          if (outputs.routePillar) {
            outputs.routePillar.textContent = "Conversion · Page Alignment";
          }
          if (outputs.routeWhy) {
            outputs.routeWhy.textContent = "One page is serving cold, warm and hot visitors the same thing, so none of them gets what they need.";
          }
        } else {
          if (outputs.routePillar) {
            outputs.routePillar.textContent = "Conversion · Friction Removal";
          }
          if (outputs.routeWhy) {
            outputs.routeWhy.textContent = "The value is landing; something specific is blocking the buy. Find the real objection and clear it.";
          }
        }
      }
    }

    Object.keys(inputs).forEach(function(key) {
      if (inputs[key]) {
        inputs[key].addEventListener("input", update);
      }
    });

    update();
  }

  document.addEventListener("DOMContentLoaded", function() {
    var root = document.querySelector("[data-conversion-calculator-root]");
    if (root) {
      initCalculator(root);
    }
  });
})();
